import React from 'react';
import { ExternalAgreement } from '@/types';
import { Modal, ModalHeader, ModalBody } from '@ygtechnologies/bygr-frontend-component-library';
import { Trans } from '@lingui/react/macro';
import { triggerHandler } from '@ygtechnologies/rubus-frontend-utilities';
import ExternalAgreementApproveWizard from './ExternalAgreementApproveWizard/ExternalAgreementApproveWizard';

interface ExternalAgreementApproveDialogProps {
    projectId: number;
    externalAgreement: ExternalAgreement;
    show: boolean;
    onClose(): void;
    onApprove(): void;
}

const ExternalAgreementApproveDialog: React.FC<ExternalAgreementApproveDialogProps> = ({
    externalAgreement,
    show,
    onClose,
    onApprove,
}) => {
    const handleApprove = async () => {
        triggerHandler(onApprove);
        triggerHandler(onClose);
    };

    return (
        <Modal size="xl" toggle={onClose} isOpen={show}>
            <ModalHeader>
                <Trans>Approve external agreement</Trans>
            </ModalHeader>
            <ModalBody>
                <ExternalAgreementApproveWizard
                    externalAgreement={externalAgreement}
                    onSaved={handleApprove}
                    onCancel={onClose}
                />
            </ModalBody>
        </Modal>
    );
};

export default ExternalAgreementApproveDialog;
